import { observer } from 'mobx-react-lite'
import { Box, Typography } from 'shared/ui'
import { AgentSwitchField } from 'pages/chatbot/ui/AgentSwitchField/AgentSwitchField'
import { useAICallingAgentManageContext } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/context'

export const EscalateToHuman = observer(() => {
  const {
    escalateToHumanStore: { isEscalate, setIsEscalate },
  } = useAICallingAgentManageContext()
  return (
    <Box margin={'12px 0'}>
      <Typography
        variant={'text-input-label-small'}
        ariaLabel={'If AI can’t help'}
        color={'var(--content-primary-secondary)'}
        tag='div'
        marginBottom={'12px'}
      >
        If AI can’t help
      </Typography>
      <AgentSwitchField
        active={isEscalate}
        onChange={setIsEscalate}
        title={'Escalate to human'}
        questionInfoTooltipProps={{
          label:
            'Automatically transfer the call back to the inbox ring group if the AI Agent can’t help or the contact requests a human.',
        }}
      />
    </Box>
  )
})
